import { PROJECT_STATUS_LABELS, type ProjectStatus } from '@lia/contracts';
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { Combobox } from '../primitives/combobox.js';

export interface ProjectOption {
  id: string;
  name: string;
  status?: ProjectStatus;
}

export interface ProjectPickerProps {
  projects: readonly ProjectOption[];
  /** null = all projects the user can access. */
  value: string | null;
  onValueChange: (projectId: string | null) => void;
  /** Hide the "all projects" choice (e.g. forms that require one project). */
  requireProject?: boolean;
  allLabel?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
  'aria-label'?: string;
  'aria-invalid'?: boolean;
  'aria-describedby'?: string;
}

/** Global project filter: "Todos los proyectos" or one specific project. */
export const ProjectPicker = React.forwardRef<HTMLButtonElement, ProjectPickerProps>(function ProjectPicker(
  { projects, value, onValueChange, requireProject, allLabel = 'Todos los proyectos', className, ...rest },
  ref,
) {
  return (
    <Combobox
      ref={ref}
      value={value}
      onValueChange={onValueChange}
      options={projects.map((p) => ({
        value: p.id,
        label: p.name,
        description: p.status && p.status !== 'active' ? PROJECT_STATUS_LABELS[p.status] : undefined,
      }))}
      placeholder={requireProject ? 'Seleccionar proyecto' : allLabel}
      searchPlaceholder="Buscar proyecto…"
      emptyText="Ningún proyecto coincide."
      clearLabel={requireProject ? undefined : allLabel}
      aria-label={rest['aria-label'] ?? 'Proyecto'}
      className={cn('w-56', className)}
      id={rest.id}
      disabled={rest.disabled}
      aria-invalid={rest['aria-invalid']}
      aria-describedby={rest['aria-describedby']}
    />
  );
});
